import { render, staticRenderFns } from "./AdminInfo.vue?vue&type=template&id=58e4910a"
import script from "./AdminInfo.vue?vue&type=script&lang=js"
export * from "./AdminInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports